import {
  init,
  identify,
  track,
  TrackParams,
  addContextFields,
  Primitives,
  addContextParams,
} from '@streamelements/alchemy';
import { isLocalHost } from '../utils/isLocalHost';

class AnalyticsService {
  private resolveIdentity = () => {};
  private identityPromise = new Promise<void>((resolve) => {
    this.resolveIdentity = () => {
      resolve();
    };
  });

  constructor() {
    init({
      cookieDomain: isLocalHost() ? 'localhost' : '.streamelements.com',
      // isDebugMode: isLocalHost(),
    });
  }

  setIdentity(params: { identity: string }) {
    identify({
      channelId: params.identity,
    });
    this.resolveIdentity();
  }

  addContextFields(params: Record<string, Primitives>) {
    addContextFields(params);
  }

  addContextParams(params: Partial<TrackParams>) {
    addContextParams(params);
  }

  async reportMultiStreamingEvent(params: Omit<TrackParams, 'product' | 'feature' | 'referer'>) {
    await this.identityPromise;

    return track({
      ...params,
      product: 'obslive',
      feature: 'multi-streaming',
      referer: 'https://selive.streamelements.com',
    }).catch(() => {
      // Likely a network error
    });
  }

  async reportLoginEvent(params: Omit<TrackParams, 'product' | 'feature' | 'referer'>) {
    await this.identityPromise;

    return track({
      ...params,
      product: 'obslive',
      feature: 'login',
      referer: 'https://selive.streamelements.com',
    }).catch(() => void 0);
  }
}

export const Analytics = new AnalyticsService();
